import { Box } from '@mui/material'
import { Loader } from 'components'
import { useCurrentUserQuery } from 'types'
import { ProfileForm } from './ProfileForm'

export const ProfileSetupScreen = () => {
  const { data: { currentUser } = {}, loading } = useCurrentUserQuery()

  if (loading || !currentUser) {
    return (
      <Box sx={{ height: '100vh' }}>
        <Loader />
      </Box>
    )
  }

  return <ProfileForm currentUser={currentUser} />
}
